import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { prorrateoMultipleApi } from "@/features/prorrateo-multiple/services/prorrateo-multiple.api";

/**
 * Lista de prorrateos por CFDI · polling cada 5s mientras la pantalla
 * está abierta para reflejar cambios remotos. Suspense para arrancar
 * con cero parpadeo (loader del route precarga).
 */
export const prorrateosQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.prorrateos(solicitudId),
    queryFn: () => prorrateoMultipleApi.listar(solicitudId),
    refetchInterval: 5_000,
    staleTime: 0,
  });

export function useProrrateos(solicitudId: string) {
  return useSuspenseQuery(prorrateosQueryOptions(solicitudId));
}
